import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface PasswordVerificationProps {
  password: string;
  errors: null | string[];
}

const PasswordVerification = ({ password, errors }: PasswordVerificationProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '-0.875rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.125rem',
          color: errors?.includes('length') ? '#d32f2f' : atLeast8Characters(password) ? '#37ac71' : '#7e828b',
        }}
      >
        <CheckCircleIcon style={{ fontSize: '0.8125rem' }} />
        <p style={{ fontSize: '0.75rem' }}>Min. 8 characters</p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.125rem',
          color: errors?.includes('lowercase') ? '#d32f2f' : includesLowercase(password) ? '#37ac71' : '#7e828b',
        }}
      >
        <CheckCircleIcon style={{ fontSize: '0.8125rem' }} />
        <p style={{ fontSize: '0.75rem' }}>Lowercase</p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.125rem',
          color: errors?.includes('uppercase') ? '#d32f2f' : includesUppercase(password) ? '#37ac71' : '#7e828b',
        }}
      >
        <CheckCircleIcon style={{ fontSize: '0.8125rem' }} />
        <p style={{ fontSize: '0.75rem' }}>Uppercase</p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.125rem',
          color: errors?.includes('number') ? '#d32f2f' : includesNumber(password) ? '#37ac71' : '#7e828b',
        }}
      >
        <CheckCircleIcon style={{ fontSize: '0.8125rem' }} />
        <p style={{ fontSize: '0.75rem' }}>Number</p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.125rem',
          color: errors?.includes('specialChar') ? '#d32f2f' : includesSpecialSymbol(password) ? '#37ac71' : '#7e828b',
        }}
      >
        <CheckCircleIcon style={{ fontSize: '0.8125rem' }} />
        <p style={{ fontSize: '0.75rem' }}>Special Character</p>
      </div>
    </div>
  );
};

function atLeast8Characters(password: string) {
  return password.length >= 8;
}

function includesLowercase(password: string) {
  return /[a-z]/.test(password);
}

function includesUppercase(password: string) {
  return /[A-Z]/.test(password);
}

function includesSpecialSymbol(password: string) {
  return /[@$!%*?&_#^()+=\/\\,.'":;{}[\]<>`~|-]/.test(password);
}

function includesNumber(password: string) {
  return /\d/.test(password);
}

export default PasswordVerification;
